export default __webpack_public_path__ + "static/media/300x250.4b5fe674.jpg";